export const REGISTER_STEPS_DATA = {
  personalInformation: {
    first_name: "",
    last_name: "",
    mobile: "",
    street: "",
    city: "",
    zip_code: undefined,
    invitation_code: "",
    country: "",
    email: "",
    password: "",
    confirm_password: "",
  },
  emailVerification: {
    email: "",
  },
  disciaimer: {
    terms: false,
  },
  uploadKYC: {
    kyc_file: null,
    type: "",
  },
  linkWallet: {
    wallet_address: "",
    status: 0,
    message: "",
  },
  caseStatus: {
    case_status: "",
  },
}
export const initWeb3State = {
  decimals: 16,
  contracts: {
    presale: {
      data: {
        claimer: null,
        min: "",
        max: "",
        remainingPresaleTotalSupply: "",
        tokenPrice: "",
        stopPresale: true,
      },
      contract: null,
    },
    bultToken: {
      data: null,
      contract: null,
    },
    affiliateCommissions: {
      data: null,
      contract: null,
    }
  },
  account: {
    address: window.ethereum?.selectedAddress?.toLowerCase() || "",
    balance: "",
    bulttBalance: "",
    walletConnectProvider: null,
  },
};